export default __webpack_public_path__ + "static/media/feedme-a-readme.a100c0a9.gif";